"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopRow = exports.Title = exports.Thumb = exports.ReadLink = exports.MinimalTop = exports.MinimalLink = exports.MinimalBanner = exports.Kicker = exports.HabitatBadge = exports.CloseButton = exports.Body = exports.BannerWrapper = exports.Accent = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../../assets/styles/colors");
const media_1 = require("../../../../utils/media");
const rise = (0, styled_components_1.keyframes) `
  from {
    opacity: 0;
    transform: translateY(1.6rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const BannerWrapper = styled_components_1.default.aside `
  position: fixed;
  left: 1.6rem;
  bottom: 1.6rem;
  width: 34rem;
  max-width: calc(100vw - 3.2rem);
  background: ${colors_1.white};
  border-radius: 1.2rem;
  overflow: hidden;
  box-shadow: 0 0.6rem 2.4rem rgba(12, 40, 60, 0.18);
  z-index: 1000;
  display: flex;
  animation: ${rise} 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;

  ${({ $compact }) => $compact
    ? (0, styled_components_1.css) `
          flex-direction: row;
          align-items: stretch;
        `
    : (0, styled_components_1.css) `
          flex-direction: column;
        `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  @media ${media_1.media.mobile} {
    left: 1.2rem;
    right: 1.2rem;
    bottom: 1.2rem;
    width: auto;
    max-width: none;
  }
`;
exports.BannerWrapper = BannerWrapper;
// --- Image variant --------------------------------------------------------
const Thumb = styled_components_1.default.div `
  position: relative;
  width: 100%;
  height: 12rem;
  overflow: hidden;
  background: ${colors_1.gray100};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;
exports.Thumb = Thumb;
// --- Compact (text-only) variant ------------------------------------------
const Accent = styled_components_1.default.div `
  flex: 0 0 0.6rem;
  background: ${colors_1.acBlue};
`;
exports.Accent = Accent;
// --- Minimal variant (A/B "minimal") --------------------------------------
// A single clickable card: no image, no button. The whole surface is the
// click target via a stretched link (MinimalLink::after covers the card).
const MinimalBanner = styled_components_1.default.aside `
  position: fixed;
  left: 1.6rem;
  bottom: 1.6rem;
  width: 34rem;
  max-width: calc(100vw - 3.2rem);
  background: ${colors_1.white};
  border-radius: 1.2rem;
  overflow: hidden;
  box-shadow: 0 0.6rem 2.4rem rgba(12, 40, 60, 0.18);
  z-index: 1000;
  display: flex;
  align-items: stretch;
  cursor: pointer;
  transition: box-shadow 0.15s ease, transform 0.15s ease, background 0.15s ease;
  animation: ${rise} 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;

  &:hover {
    background: ${colors_1.gray100};
    box-shadow: 0 0.9rem 3rem rgba(12, 40, 60, 0.26);
    transform: translateY(-0.2rem);
  }

  &:hover p:last-of-type,
  &:focus-within p:last-of-type {
    text-decoration: underline;
    text-decoration-color: ${colors_1.acBlue};
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transition: none;
    &:hover {
      transform: none;
    }
  }

  @media ${media_1.media.mobile} {
    left: 1.2rem;
    right: 1.2rem;
    bottom: 1.2rem;
    width: auto;
    max-width: none;
  }
`;
exports.MinimalBanner = MinimalBanner;
// Invisible anchor whose ::after overlay makes the entire card clickable.
// The close button sits above this overlay (higher z-index) so it stays usable.
const MinimalLink = styled_components_1.default.a `
  text-decoration: none;
  color: inherit;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
  }

  body:not(.user-is-tabbing) &:focus-visible {
    outline: none;
  }
`;
exports.MinimalLink = MinimalLink;
// --- Shared ----------------------------------------------------------------
const HabitatBadge = styled_components_1.default.div `
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: ${({ $onImage }) => ($onImage ? colors_1.gray400 : colors_1.gray300)};

  img {
    height: 1.6rem;
    width: auto;
    display: block;
  }

  ${({ $onImage }) => $onImage &&
    (0, styled_components_1.css) `
      position: absolute;
      top: 1rem;
      left: 1rem;
      background: rgba(255, 255, 255, 0.94);
      border-radius: 2rem;
      padding: 0.4rem 0.9rem;
      box-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.15);
      z-index: 2;
    `}
`;
exports.HabitatBadge = HabitatBadge;
const CloseButton = styled_components_1.default.button `
  border: none;
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
  width: 2.6rem;
  height: 2.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $onImage }) => $onImage ? "rgba(255, 255, 255, 0.9)" : colors_1.gray100};
  box-shadow: ${({ $onImage }) => $onImage ? "0 0.1rem 0.4rem rgba(0, 0, 0, 0.2)" : "none"};

  img {
    width: 1.2rem;
    height: 1.2rem;
    object-fit: contain;
  }

  &:hover {
    background: ${({ $onImage }) => $onImage ? colors_1.white : "rgba(0, 0, 0, 0.06)"};
  }

  ${({ $onImage }) => $onImage &&
    (0, styled_components_1.css) `
      position: absolute;
      top: 0.9rem;
      right: 0.9rem;
      z-index: 3;
    `}

  body:not(.user-is-tabbing) &:focus-visible {
    outline: none;
  }
`;
exports.CloseButton = CloseButton;
const Body = styled_components_1.default.div `
  padding: 1.4rem 1.6rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  flex: 1;
  min-width: 0;
`;
exports.Body = Body;
const TopRow = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
`;
exports.TopRow = TopRow;
// Same as TopRow but lifted above the minimal variant's stretched-link overlay
// so the close button remains clickable.
const MinimalTop = (0, styled_components_1.default)(TopRow) `
  position: relative;
  z-index: 2;
`;
exports.MinimalTop = MinimalTop;
const Kicker = styled_components_1.default.p `
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${colors_1.acBlue};
`;
exports.Kicker = Kicker;
const Title = styled_components_1.default.p `
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.25;
  color: ${colors_1.gray400};
  overflow-wrap: break-word;
`;
exports.Title = Title;
const ReadLink = styled_components_1.default.a `
  align-self: flex-start;
  margin-top: 0.4rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: ${colors_1.acBlue};
  color: ${colors_1.white};
  text-decoration: none;
  font-size: 1.4rem;
  font-weight: 700;
  padding: 0.9rem 1.6rem;
  border-radius: 0.8rem;
  transition: background 0.15s;

  &:hover {
    background: ${colors_1.acBlueDark};
  }
`;
exports.ReadLink = ReadLink;
